import ReactOnRails from 'react-on-rails';

import SkillQuestionShowSSR from '../bundles/skill-question-show/SkillQuestionShowSSR';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  SkillQuestionShowSSR,
} as any)
